import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { Button } from '@stepstone-genesis/components';
import { useEffect } from 'react';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
import { API_URLS } from '../../../../configs/constants/urls.js';
import { toRelativeUrl } from '../../../../helpers/url/url.js';
import { redirectingStatusSelector, setIsRedirecting, } from '../loginWithLinkedInSlice.js';
import { redirectToLinkedIn } from '../service/index.js';
import { useAppDispatch, useAppSelector } from '../../../hooks.js';
export const ImportProfileButton = ({}) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const redirectingStatus = useAppSelector(redirectingStatusSelector);
    const isRedirecting = (status) => dispatch(setIsRedirecting(status));
    useEffect(() => {
        if (redirectingStatus) {
            dispatch(isRedirecting(false));
        }
    }, []);
    const onImportProfile = () => {
        trackBtnClick({ uniqueName: 'importProfile' });
        isRedirecting(true);
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('linkedInShowImportProfile');
        const cleanRelativeUrl = typeof window !== 'undefined' ? toRelativeUrl(cleanUrl.toString()) : null;
        redirectToLinkedIn({ redirect_to: cleanRelativeUrl }, API_URLS.CANDIDATE_PROFILE.LINKEDIN_IMPORT_PROFILE);
    };
    const { trackBtnClick } = useTrack('linkedin');
    return (_jsx(Button, { "data-testid": "import-profile-linkedin-btn", as: "button", variant: "primary", a11yLabel: "import linkedin profile", type: "button", isLoading: redirectingStatus, isFullWidth: true, size: ['medium'], onClick: onImportProfile, children: t('loginregistration.linkedIn.importProfile.importButton') }));
};
//# sourceMappingURL=ImportProfileButton.js.map